import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const IDSDescriptionList = ({ list, useColumnView }) => {
  if (!list || list.length <= 0) {
    return null;
  }

  const useClasses = classNames({
    'ids-description-list': true,
    ['ids-description-list--column']: useColumnView,
  });

  return (
    <dl className={useClasses}>
      {list.map((item, index) => {
        return <Row key={index} rowItem={item} />;
      })}
    </dl>
  );
};

const Row = ({ rowItem }) => {
  if (!rowItem) {
    return null;
  }

  return (
    <>
      <dt className="ids-description-list__term">{rowItem?.Term}</dt>
      <dd className="ids-description-list__description">
        {rowItem?.DescriptionItems.map((descItem, index) => (
          <span
            key={index}
            className="ids-description-list__description__value"
          >
            {descItem}
          </span>
        ))}
      </dd>
    </>
  );
};

IDSDescriptionList.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      Term: PropTypes.string,
      DescriptionItems: PropTypes.arrayOf(PropTypes.string),
    })
  ),
  useColumnView: PropTypes.bool,
};

export default IDSDescriptionList;
